<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                this.$store.commit('setValue', {
                    key: 'isIndustrial',
                    value: selectedItem.isIndustrial,
                })

                if (!selectedItem.isIndustrial) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industryId',
                        value: null,
                    })
                }
            }
        },
    }, // End of Component > watch
}
</script>
